import { render } from "./student-dashboard.vue?vue&type=template&id=06085585"
import script from "./student-dashboard.vue?vue&type=script&lang=js"
export * from "./student-dashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__